import { render, staticRenderFns } from "./PAPDropdown.vue?vue&type=template&id=c7073df8&scoped=true&"
import script from "./PAPDropdown.vue?vue&type=script&lang=js&"
export * from "./PAPDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7073df8",
  null
  
)

export default component.exports